
<template>
  <div>
    <!-- Page Header -->
    <Header :topHeader="''" :headerText="header" :overview="overview" />
    <!-- Page Content -->
    <div class="row no-gutters mr-md-4 mt-md-3 ml-md-1 w-md-75">
      <div class="col-12 col-md-12">
        <div :class="['card', 'task-manager-card', 'pb-md-5', cardHeight]">
          <!-- task-creation-row -->
          <create-task
            v-if="overview == undefined"
            @setBulkFlag="bulkFlag"
            @whichTasks="whichTasks"
            @name="searchByName"
          />

          <!-- search-row -->
          <search v-if="overview == undefined" @saveSearch="saveSearch" />

          <!-- task-table- -->
          <task-table
            :fields="fields"
            :tasks="filteredTasks"
            :notificationField="notificationField"
            :overviewFields="overview == undefined"
            @showTask="taskView"
          />

          <!-- create-simple-task -->
          <create-simple-task
            :bulk="isBulk"
            @pushInTasksArray="updateTasksArray"
          />

          <!-- simple-task-explaination-modal -->
          <simple-task-view
            :task="task"
            :selectedEmployees="selectedEmps"
            @deleteTask="deleteSimpleTask"
          />

          <!-- create-bulk-task-modal -->
          <edit-task @pushInTasksArray="updateTasksArray" />

          <!-- bulk-task-explaination-modal -->
          <bulk-task-view
            :task="task"
            @deleteTask="deleteSimpleTask"
            @showTask="taskView"
          />

          <confirm @delete="deleteTask" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from '@/components/shared/header';
import CreateTask from '@/components/task/createTask';
import TaskTable from '@/components/task/taskTable';
import Search from '@/components/task/search';
import CreateSimpleTask from '@/components/modals/createSimpleTask';
import SimpleTaskView from '@/components/modals/simpleTaskView';
import EditTask from '@/components/modals/editTask';
import BulkTaskView from '@/components/modals/bulkTaskView';
import Confirm from '@/components/modals/confirm';
import TimeUtils from '../../utils/TimeUtils';
import TaskHelper from '../../helper/TaskHelper';

export default {
  props: ['columns', 'personalTasks', 'headerText', 'overview'],
  components: {
    Header,
    CreateTask,
    TaskTable,
    Search,
    CreateSimpleTask,
    SimpleTaskView,
    EditTask,
    BulkTaskView,
    Confirm,
  },

  mounted() {
    this.user = this.$store.state.user.informations;
    this.fetchTasks();
  },

  data() {
    return {
      isBulk: false,
      deleteFlag: false,
      deleteReference: '',
      managerCols: [
        'Title',
        'AssignedTo',
        'CreationDate',
        'DueDate',
        '',
        'Status',
      ],
      managerTasks: [],
      filteredTasks: [],
      task: {},
      flag: false,
      selectedEmps: [],
      user: {},
    };
  },

  computed: {
    fields() {
      return this.columns ? this.columns : this.managerCols;
    },

    tasks() {
      return this.personalTasks ? this.personalTasks : this.managerTasks;
    },

    header() {
      return this.headerText
        ? this.headerText
        : this.$t('task.header.titleManager');
    },

    notificationField() {
      return !this.columns;
    },

    cardHeight() {
      return this.tasks.length || 'task-manager-card-height';
    },
  },

  methods: {
    bulkFlag(flag) {
      this.isBulk = flag;
    },

    deleteTask(flag) {
      this.deleteFlag = flag;
      if (flag) { this.deleteSimpleTask(this.deleteReference); }
    },

    fetchTasks(type) {
      const taskId = this.$route.params.reference;
      if (taskId) {
        this.$services.task
          .managerCreatedTasks(`/task/${taskId}`)
          .then((res) => {
            this.task = res.data[0].task;
            this.selectedEmps = this.task.users;
            if (this.task.bulk) {
              this.$modal.show('bulk-task-view');
            } else {
              this.$root.$emit('simpleTaskView', this.task.reference);
              this.$modal.show('simple-task');
            }
          });
      }
      const currentUserId = this.user.reference;
      this.$services.task
        .managerCreatedTasks('/task/all', currentUserId, type)
        .then((res) => {
          this.managerTasks = res.data;
        });
    },

    whichTasks(type) {
      if (this.$route.path == '/personalTasks') {
        this.$emit('personalDateRange', type);
      } else this.fetchTasks(type);
    },

    saveSearch(search) {
      this.filteredTasks = [];
      const tasks = this.personalTasks ? this.personalTasks : this.managerTasks;
      tasks.filter((t) => {
        const task = t.task;
        if (
          this.checkDueDate(task.dueDate, search.dueDate) &&
          this.checkCreationDate(
            task.createdBy.creationDate,
            search.creationDate,
          ) &&
          this.checkGroupName(task.users, search.groupName)
        ) {
          this.filteredTasks.push(t);
        }
      });
    },

    fillFilteredReports(tasks) {
      this.filteredTasks = tasks;
    },

    checkDueDate(date, dueDate) {
      return !dueDate
        ? true
        : TimeUtils.dayMonYear(date) == TimeUtils.dayMonYear(dueDate);
    },

    groupsInTask(users) {
      const groupsOfUsers = [];
      users.forEach((user) => {
        user.groupReference.forEach((gr) => {
          groupsOfUsers.push(gr);
        });
      });
      return groupsOfUsers;
    },

    checkGroupName(users, groupName) {
      const groupsInSingleTask = this.groupsInTask(users);
      return !groupName ? true : groupsInSingleTask.includes(groupName);
    },

    checkCreationDate(date, creationDate) {
      return !creationDate
        ? true
        : TimeUtils.dayMonYear(date) == TimeUtils.dayMonYear(creationDate);
    },

    searchByName(name) {
      this.filteredTasks = [];
      const tasks = this.personalTasks ? this.personalTasks : this.managerTasks;
      tasks.filter((task) => {
        let flag = true;
        task.task.users.forEach((user) => {
          if (
            flag &&
            (user.firstName.toLowerCase().match(name.toLowerCase()) ||
              user.lastName.toLowerCase().match(name.toLowerCase()) ||
              user.firstName.toUpperCase().match(name.toUpperCase()) ||
              user.lastName.toUpperCase().match(name.toUpperCase()) ||
              task.task.title.toLowerCase().match(name.toLowerCase()) ||
              task.task.title.toUpperCase().match(name.toUpperCase()))
          ) {
            this.filteredTasks.push(task);
            flag = false;
          }
        });
      });
    },

    taskView(task, emps) {
      this.task = task.task;
      this.selectedEmps = emps;
    },

    deleteSimpleTask(reference) {
      if (!this.deleteFlag) {
        this.deleteReference = reference;
        this.$modal.show('confirm');
      } else if (
        this.task.bulk &&
        this.selectedEmps &&
        this.selectedEmps.length
      ) {
        const users = this.task.users.filter(u => u.reference != this.selectedEmps[0].reference);
        this.task.users = users;
        const status = TaskHelper.updateTask(this.task);
        if (status) {
          this.onDeletion('simple-task');
        } else this.$miniToastr.error(this.$t('global.noDeleteToaster'));
      } else {
        this.$services.task.deleteTask(reference).then((res) => {
          if (res.data.success) {
            const modal = this.task.bulk ? 'bulk-task-view' : 'simple-task';
            const tasks = this.filteredTasks.filter(task => task.task.reference != reference);
            this.filteredTasks = tasks;
            this.task.reference = '';
            this.onDeletion(modal);
          } else {
            this.$miniToastr.error(this.$t('global.noDeleteToaster'));
          }
        });
      }
    },

    onDeletion(modal) {
      this.$modal.hide(modal);
      this.$miniToastr.success(this.$t('global.deleteToaster'));
      const desc = `${this.task.createdBy.firstName} ${this.task.createdBy.lastName} a supprimé une tache`;
      this.sendNotification(this.task, desc);
      if (this.$route.params.reference) {
        this.$router.back(-1);
      }
    },

    async sendNotification(task, description) {
      let users = [];
      if (this.selectedEmps && this.selectedEmps.length) {
        users = this.selectedEmps;
      } else {
        users = task.users;
      }
      const status = TaskHelper.sendNotification(task, users, description);
      if (status) {
        this.$miniToastr.success(this.$t('global.notificationToaster'));
      } else this.$miniToastr.error('global.noNotificationToaster');
    },

    updateTasksArray() {
      if (this.$route.path == '/personalTasks') {
        this.$root.$emit('personalTasks');
      } else {
        this.fetchTasks();
      }
    },
  },

  watch: {
    tasks: {
      handler: 'fillFilteredReports',
    }, // just invoking the computed property
  },
};
</script>
<style lang="scss" scoped>
.btn-done {
  width: 102px;
  height: 30px;
  object-fit: contain;
  border-radius: 3px;
  border: solid 1px #17c671;
  background-color: rgba(23, 198, 113, 0.24);
  color: #17c671;
  font-family: "SF-Pro-Text";
  font-size: 11px;
}
.lord-more {
  width: 120px;
  margin: 30px auto 0 auto;
  .loard-more-btn {
    display: block;
    width: 100%;
    border: 1px solid #becad6;
    background-color: transparent;
    height: 35px;
    border-radius: 3px;
    color: #5a6169;
    font-family: "SF-Pro-Text";
    outline: none;
  }
}

.btn-pedding {
  width: 102px;
  height: 30px;
  object-fit: contain;
  border-radius: 3px;
  border: solid 1px #ffb400;
  background-color: rgba(255, 180, 0, 0.24);
  color: #ffb400;
  font-family: "SF-Pro-Text";
  margin: 0 auto;
  font-size: 11px;
}

.modal-2-table {
  thead {
    tr {
      th {
        color: #303778;
        font-family: "SF-Pro-Text";
        padding: 10px 0;
      }
    }
  }
  tbody {
    tr {
      td {
        color: #212529;
        font-family: "SF-Pro-Text";
        font-weight: 500;
        padding: 9px 0;
        vertical-align: middle;
        border-bottom: 1px solid #ddd;
      }
    }
  }
}
.modal-tabel-2 {
  margin: 0 auto;
  width: 90%;
}
.uplord-and-submit-btn {
  button {
    margin-right: 4px;
  }
}
.modal-head-2 {
  position: relative;
  .task-modal-close {
    position: absolute;
    right: 15px;
    a {
      font-size: 30px;
      cursor: pointer;
      font-weight: 700;
    }
  }
  .main-title-modal {
    p {
      font-family: "SF-Pro-Text";
      color: #212529;
      font-size: 14px;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 12px;
      }
    }
  }
  .modal-head-description {
    h3 {
      font-size: 26px;
      font-family: "SF-Pro-Text";
      color: #212529;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 17px;
      }
    }
  }
  .modal-description-btn {
    .btn-label {
      background-color: #e8e9f0;
      display: inline-block;
      padding: 4px 40px 4px 20px;
      border: 0;
      border-radius: 3px;
      font-family: "SF-Pro-Text";
      color: #303778;
      font-weight: 500;
      font-size: 14px;
      outline: none;
      height: 35px;
      position: relative;
      @media (min-width: 320px) and (max-width: 600px) {
        font-size: 12px;
      }
      .close-icon-btn {
        position: absolute;
        right: 12px;
        top: 0;
        width: 15px;
        line-height: 35px;
        text-align: center;
        font-size: 15px;
        font-weight: 700;
        border-left: 1px solid #d8cfcf;
        border-radius: 0;
        height: 35px;
        padding-left: 8px;
        color: #9e8d8d;
      }
    }
  }
}
.task-manager-card-height {
  height: 70vh;
}

.task-manager-card {
  @media (min-width: 320px) and (max-width: 600px) {
    width: 90%;
    margin: 0 auto;
    height: auto;
  }
}

.commient-bg-color {
  padding: 15px 0 30px 0;
  background-color: #f6f8ff;
  margin-top: 15px;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.heading-unorder {
  margin: 0;
  padding: 0;
  li {
    display: inline;
    padding-right: 10px;
  }
}
.attachment-btn {
  border: solid 1px #becad6;
  background-color: #ffffff;
  padding: 4px 15px;
  border-radius: 3px;
  font-size: 11px;
  font-family: "SF-Pro-Text";
  outline: none;
  color: #5a6169;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

@mixin input-field-style {
  input {
    border-radius: 3px;
    border: solid 1px #becad6;
    background-color: #fff;
    color: #cacedb;
    font-size: 14px;
    height: 36px;
    &::placeholder {
      /* Chrome, Firefox, Opera, Safari 10.1+ */
      color: #cacedb;
      opacity: 1; /* Firefox */
    }

    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #cacedb;
    }

    &::-ms-input-placeholder {
      /* Microsoft Edge */
      color: #cacedb;
    }
  }
}
.form-field-style-1 {
  @include input-field-style;
  @media (min-width: 320px) and (max-width: 767px) {
    width: 100%;
  }
}
.form-field-style-2 {
  @include input-field-style;
  margin-right: 10px;
  @media (min-width: 320px) and (max-width: 767px) {
    width: 100%;
    text-align: left;
  }
}
.form-field-style-4 {
  @include input-field-style;
  width: 45%;
  @media (min-width: 1090px) and (max-width: 1292px) {
    width: 200px;
  }
  @media (min-width: 993px) and (max-width: 1090px) {
    width: 160px;
  }
  input {
    padding-left: 40px;
    text-align: left;
  }
}

// .form-field-style-5 {
//   width: 110px;
//   .create-new-btn {
//     background-color: #4f78e2;
//     width: 100%;
//     height: 35px;
//     border: none;
//     border-radius: 3px;
//     color: #fff;
//     font-family: "SF-Pro-Text";
//     font-weight: 500;
//     &:focus {
//       outline: none;
//     }
//   }
// }
.group-filter-bg {
  background-color: #f6f8ff;
  @media (min-width: 320px) and (max-width: 600px) {
    padding: 20px 20px 0 20px;
  }
}

.v--modal-overlay {
  position: absolute;
}
</style>
